<template>
  <td>
    <div class="dropBox">
      <v-checkbox
        color="primary"
        class="mt-0"
        hide-details
        style="display: inline-block;"
        v-model="dropBoxForm.enabled"
        label="DropBox"
        @change="hide = (dropBoxForm.enabled ? !dropBoxForm.enabled : hide)"
      />
      <v-icon style="cursor-pointer" @click="hide = !hide">{{ hide ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
    </div>
    <div v-show="!hide" class="google-security">
      <v-form
        id="dropbox-form"
        ref="dropBoxForm"
        v-model="hasCode"
        lazy-validation
      >
        <v-btn :loading="popupOpen" @click.stop="popupFix"><v-icon v-if="hasCode" class="mr-2" dark>mdi-check-circle-outline</v-icon>&nbsp;&nbsp;Connect to DropBox</v-btn>
        <v-input
          v-model="dropBoxForm.data.apiCode"
          :rules="[v => !!v || 'DropBox not connected.']"
        ></v-input>
      </v-form>
    </div>
  </td>
</template>
<script>
export default {
  name: 'DropBoxConfigureForm',
  props: ['dropBox'],

  created () {
    this.dropBoxForm = this.dropBox
  },

  mounted () {
  },

  beforeDestroy () {
    window.removeEventListener('message', this.onMessage)
  },

  computed: {
    hasCode: {
      get () {
        return !!this.dropBoxForm?.data?.apiCode
      },
      set (value) {
        this.value = value
      }
    }
  },

  data () {
    return {
      dropBoxForm: null,
      hide: true,
      rules: {
        required: v => !!v || 'Required.'
      },
      popupOpen: false
    }
  },

  methods: {
    setDropBox () {
      this.$emit('setData', 'dropBox', this.dropBoxForm)
    },
    popupFix () {
      window.addEventListener('message', this.onMessage, false)
      const newWindow = this.openWindow('', 'login')
      this.login(newWindow)
      const vm = this
      vm.popupOpen = true
      var timer = setInterval(function () {
        if (newWindow.closed) {
          clearInterval(timer)
          vm.popupOpen = false
        }
      }, 1000)
    },
    openWindow (url, title, options = {}) {
      if (typeof url === 'object') {
        options = url
        url = ''
      }
      options = { url, title, width: 600, height: 720, ...options }
      const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left
      const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top
      const width = window.innerWidth || document.documentElement.clientWidth || window.screen.width
      const height = window.innerHeight || document.documentElement.clientHeight || window.screen.height
      options.self = '_self'
      options.left = ((width / 2) - (options.width / 2)) + dualScreenLeft
      options.top = ((height / 2) - (options.height / 2)) + dualScreenTop
      const optionsStr = Object.keys(options).reduce((acc, key) => {
        acc.push(`${key}=${options[key]}`)
        return acc
      }, []).join(',')
      const newWindow = window.open(url, title, optionsStr)
      if (!newWindow) {
        console.log('Please unblock popups in your browser settings to login with Github')
      } else if (window.focus) {
        newWindow.focus()
      }
      return newWindow
    },
    async login (newWindow) {
      const url = `https://www.dropbox.com/oauth2/authorize?client_id=${process.env.VUE_APP_DROPBOX_APP_KEY}&response_type=code&token_access_type=legacy&redirect_uri=${window.location.origin}/auth/callback/dropbox`
      newWindow.location.href = url
    },
    onMessage (e) {
      if (e.origin !== window.origin) {
        return
      }
      if (e.data?.source === 'auth-callback' && e.data.provider === 'dropbox') {
        const dbxData = {
          apiCode: e.data.data.code,
          appKey: process.env.VUE_APP_DROPBOX_APP_KEY,
          appSecret: process.env.VUE_APP_DROPBOX_APP_SECRET,
          redirectUrl: `${window.location.origin}/auth/callback/dropbox`
        }
        this.dropBoxForm = { valid: true, data: dbxData, enabled: true }
        this.setDropBox()
      }
    }
  }
}
</script>
<style lang="css" scoped>
  .dropBox {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  #dropbox-form >>> div.v-input__slot {
    height: 8px;
    min-height: 8px;
  }
</style>
